// intentionally duplicated until the theme cpode consolidation is completed
function ARNE_DOMApply( root, selector, op )
{
    var elements = root.querySelectorAll( selector );
    elements.forEach( function( element )
    {
        op( element );
    } );
}



// moved from inline script
$(document).ready(function() 
{
    $('.arne-collection-container').on('init', function(event, slick) 
    {
        $('.mix_match_slider_wrapper').fadeIn();
    });

    ARNE_DOMApply( document, '.arne-collection-container', function( element )
    {
        try
        {
            var children = element.children.length;

            if ( children > 0 )
            {
                var param =
                {
                    "infinite"       : true,
                    "slidesToShow"   : children >= 6 ? 6 : children,
                    "slidesToScroll" : 1,
                    "arrows"         : true,
                    "prevArrow"      : '<button type="button" class="slick-prev"><i class="fa fa-chevron-left"></i></button>',
                    "nextArrow"      : '<button type="button" class="slick-next"><i class="fa fa-chevron-right"></i></button>',
                    "responsive"     :
                    [
                    {
                        "breakpoint" : 1000,
                        "settings"   :
                        {
                            "slidesToShow"   : children >= 2 ? 2 : children,
                            "slidesToScroll" : children >= 2 ? 2 : children,
                        }
                    }
                    ]
                };

                $( element ).slick( param );
            }
        }
        catch ( e )
        {
            console.log( "slick error : ", e.stack );
        }
    } );
});
